module.exports = __webpack_public_path__ + "static/media/airbrake-MX-remove-japanese.43ab07fb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/switchlock/video/jp/airbrake-MX-remove-japanese.mp4
// module id = 3470
// module chunks = 0